auth.component('auth.resetComponent', {
    templateUrl: 'auth/reset/reset.html',
    controller: 'auth.resetController'
});

auth.controller('auth.resetController', ['$scope', '$location', 'coreFb', 'coreLanguage', '$state', function($scope, $location, $fb, $text, $state) {

    $scope.$text = $text;
    const $ctrl = this;

    $ctrl.isSubmiting = false;
    $ctrl.submitError = false;

    $ctrl.showPassword = false;

    $ctrl.formData = {
        pass: '',
        email: false
    };

    $ctrl.formErrors = {
        pass: {},
        email:{}
    };

    const _login = (email, pass) => {
        $fb.auth.login(email, pass).then((cred) => {
            return cred.user.getIdTokenResult().then((res) => {
                if (!res.claims.nivel || res.claims.nivel < 1) {
                    $fb.auth.logout();
                    throw new Error();
                }
                $state.go('cliente');
            });
        }).catch((e) => {
            $ctrl.submitError = true;
            $ctrl.formErrors.password = {
                field: true,
                hint: false
            };
            
        }).finally(() => {
            $ctrl.isSubmiting = false;
        });
    };

    const _validateFields = () => {

        Object.keys($ctrl.formErrors).forEach((name) => {
            $ctrl.formErrors[name] = {
                field: !$scope.resetForm[name].$valid,
                hint: !$scope.resetForm[name].$valid
            };
        });
    };

    $ctrl.onBlur = (name) => {
        $ctrl.formErrors[name] = {
            field: !$scope.resetForm[name].$valid,
            hint: !$scope.resetForm[name].$valid
        };
    };

    $ctrl.onSubmit = () => {

        if (!$scope.resetForm.$valid) {
            _validateFields();
            return
        }

        $ctrl.isSubmiting = true;
        $ctrl.submitError = false;
        $ctrl.formErrors = { pass:{}, email:{}};

        $fb.auth.resetPass($ctrl.formData.email, $ctrl.formData.pass).then((res) => {
            _login($ctrl.formData.email, $ctrl.formData.pass);
        }).catch((e) => {
            $ctrl.submitError = true;
            $ctrl.errorMsg = $text.somethingWrong;
            $ctrl.formErrors.pass = { field: true, hint: false };
        }).finally(() => {
            $ctrl.isSubmiting = false;
        });
    };

    $ctrl.togglePassword = () => {
        $ctrl.showPassword = !$ctrl.showPassword;
    };

    $ctrl.$onInit = () => {
        $scope.form = {};
        $ctrl.formData.email = $location.search().email || false;
    };
}]);